// Polyfills
import 'formdata-polyfill';

//import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';
import loadMore from './modules/load-more';
import Form from './modules/form';
import MultiSelect from './modules/multiselect';

const $ = window.$ || window.jQuery;
window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
  branchBar.init();
  loadMore.init();

  if (document.getElementById('map-canvas')) {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/maps/api/js?key=AIzaSyCxryFj8UQujiy3iEHz0wc6CxgaT_u85ts&amp;callback=initialize';
    script.onload = () => {
      window.initialize('map-canvas', window.tallqvistMarkers);
    };
    document.head.appendChild(script);
  }

  $('form.ajax-form').each(function() {
    const $form = $(this);
    if (!$form.data('ajax-form-state')) {
      new Form($form);
    }
  });

  if (document.querySelector('.js-app-news')) {
    import('./modules/app-news').then((news) => news.default.init());
  }

  if (document.querySelectorAll('[data-multi-select]')) {
    document.querySelectorAll('[data-multi-select]').forEach(select => new MultiSelect(select, {selectAll: false }));
  }
});
